export const componentTheme = {
  breadcrumbs: {
    defaultProps: {
      className: '',
      fullWidth: false,
      separator: '/',
    },
    styles: {
      base: {
        root: {
          initial: {
            width: 'w-max',
          },
          fullWidth: { display: 'block', width: 'w-full' },
        },
        list: {
          display: 'flex',
          flexWrap: 'flex-wrap',
          alignItems: 'items-center',
          width: 'w-full',
          bg: 'none',
          bgOpacity: 'bg-opacity-60',
          py: 'py-2',
          px: 'none',
          borderRadius: 'rounded-md',
        },
        item: {
          initial: {
            display: 'flex',
            alignItems: 'items-center',
            color: 'text-[#707070]',
            fontSmoothing: 'antialiased',
            fontFamily: 'font-NanumSquarNeo',
            fontSize: 'text-[14px]',
            fontWeight: 'font-normal',
            lineHeight: 'leading-normal',
            cursor: 'cursor-pointer',
            transition: 'transition-colors duration-200',
            hover: 'hover:text-[#ff7f7f]',
          },
          disabled: {
            pointerEvents: 'pointer-events-none',
          },
        },
        separator: {
          color: 'text-blue-gray-500',
          fontSize: 'text-sm',
          fontSmoothing: 'antialiased',
          fontFamily: 'font-sans',
          fontWeight: 'font-normal',
          lineHeight: 'leading-normal',
          px: 'mx-2',
          pointerEvents: 'pointer-events-none',
          userSelcet: 'select-none',
        },
      },
    },
  },
};
/**
 * component    :	사용자 정의하려는 구성 요소의 이름입니다.예)button.
 * defaultProps :	구성 요소의 기본 props 값을 변경하는 데 사용됩니다.
 * valid        :	구성 요소 소품 유효성 검사에 유효한 값을 변경하는 데 사용됩니다.
 * styles       :	구성 요소의 스타일을 변경하는 데 사용됩니다.
 */
